import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// ルート変更のたびにページ最上部へスクロールする（React Routerはデフォルトでスクロール位置を引き継ぐため）
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export default ScrollToTop;
